// extracted by mini-css-extract-plugin
module.exports = {"timePlotterButton":"BlackButton_timePlotterButton__2ErrW","timePlotterIcon":"BlackButton_timePlotterIcon__3yxYK"};